import React from "react";

import { queries } from "lib/build/dashboards/htx/queries";
import { Status } from "lib/build/forms/htx/patientCondition";

import { SafeFormattedMessage } from "src/common/components/SafeFormattedMessage";
import { useLastEventValueByQuery } from "src/features/events";
import { shortStatusMessages } from "src/modules/htx/messages";

export const ShortStatus: React.FunctionComponent = () => {
	const status =
		useLastEventValueByQuery<Status>(queries.patientStatus) || Status.NEW;
	return (
		<SafeFormattedMessage
			messages={shortStatusMessages}
			messageKey={status}
		/>
	);
};
